import React, { useEffect, useState } from 'react';
import { LoginForm } from './LoginForm';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import { ResetPasswordForm } from './ResetPasswordForm';
import { AuthShell } from './AuthShell';

type AuthMode = 'login' | 'forgot-password' | 'reset-password';

export const AuthContainer: React.FC = () => {
  const [authMode, setAuthMode] = useState<AuthMode>('login');
  const [resetToken, setResetToken] = useState<string>('');

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');

    if (token) {
      setResetToken(token);
      setAuthMode('reset-password');
    }
  }, []);

  const handleForgotPassword = () => {
    setAuthMode('forgot-password');
  };

  const handleBackToLogin = () => {
    setAuthMode('login');
    setResetToken('');
  };

  const handleAuthSuccess = () => {
    // This will be handled by the parent component
    console.log('Auth successful');
  };

  const handleAuthError = (error: string) => {
    console.error('Auth error:', error);
  };

  let content: React.ReactNode;

  switch (authMode) {
    case 'forgot-password':
      content = (
        <ForgotPasswordForm
          onSuccess={handleAuthSuccess}
          onError={handleAuthError}
          onBackToLogin={handleBackToLogin}
        />
      );
      break;

    case 'reset-password':
      content = (
        <ResetPasswordForm
          token={resetToken}
          onSuccess={handleAuthSuccess}
          onError={handleAuthError}
          onBackToLogin={handleBackToLogin}
        />
      );
      break;

    default:
      content = (
        <LoginForm
          onSuccess={handleAuthSuccess}
          onError={handleAuthError}
          onForgotPassword={handleForgotPassword}
        />
      );
      break;
  }

  return <AuthShell>{content}</AuthShell>;
};
